export const DEFAULT_QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min
export const DEFAULT_QUERY_STALE_TIME = 15 * 60 * 1000 // 15 min
